let serverhost = 'https://www.liangshishu.link:46888';
// let serverhost = 'https://www.liangshishu.link:47886';
let loginAPIUrl = 'https://www.liangshishu.link:46888/token';
// let loginAPIUrl = "https://www.liangshishu.link:47886/token";

if (process.env.REACT_APP_NODE_ENV === 'development') {
  serverhost = 'https://www.liangshishu.link:46890';
  // serverhost = 'https://www.liangshishu.link:47886';
  loginAPIUrl = 'https://www.liangshishu.link:46890/token';
  // loginAPIUrl = "https://www.liangshishu.link:47886/token";
}

export const loginAPI = {
  POST: loginAPIUrl,
};

export const staffListAPI = {
  GET: `${serverhost}/api/User`,
  Edit: `${serverhost}/api/User`,
  GETALL: `${serverhost}/api/User/All`,
  UPDATEUSERJOB: `${serverhost}/api/User/UpdateJob`
};
export const leaveRecAPI = {
  GET: `${serverhost}/api/LeaveRec/Pending`,
};

export const jobTypeAPI = {
  GET: `${serverhost}/api/JobType`,
};

// 班表API
export const ScheduleAPI = {
  ACTUALEVENTDETAIL: `${serverhost}/api/Event/ActualDetail`,
  HOURCOSTCHART: `${serverhost}/api/Chart/DailyCost`,
  MIN30COSTCHART: `${serverhost}/api/Chart/Daily30MinCost`,
  ACCUMULATECOSTCHART: `${serverhost}/api/Chart/AccumulateCost`,

  GET: `${serverhost}/api/Event/Schedule`,
  // 個人簽到表
  ATTENDANCE: `${serverhost}/api/Event/AttendanceSheet`,
  // 預期工時表
  EXPECTED: `${serverhost}/api/Event/ExpectedWorkTimeSheet`,
  // 預期當日工時表
  EXPECTEDBYDATE: `${serverhost}/api/Event/ExpectedWorkTimeSheetDetail`,
  // 最終工時表
  FINAL: `${serverhost}/api/Event/FinalWorkTimeSheet`,
  // 最終當日工時表
  FINALBYDATE: `${serverhost}/api/Event/FinalWorkTimeSheetDetail`,
  // 調整班表
  ADJUSTMENTSCHEDULE: `${serverhost}/api/Event/AdjustmentSchedule`,
  // 調整班表-日期
  ADJUSTMENTSCHEDULEDETAIL: `${serverhost}/api/Event/AdjustmentScheduleDetail`,
  // 公告班表 假日
  HOLIDAY: `${serverhost}/api/Holiday`,
  INCOME: `${serverhost}/api/income`,
  ACTIVE: `${serverhost}/api/Event`,
  ADDSTAFFINADJUST: `${serverhost}/api/Event/Adjust`,
  EMPLOYEESALARYSHEET: `${serverhost}/api/Event/EmployeeSalarySheet`,
  // 支援班表
  SUPPORT: `${serverhost}/api/Event/SupportSchedule`,
  SUPPORTDETAIL: `${serverhost}/api/Event/SupportScheduleDetail`,
  // 彙整
  PeopleStatistic: `${serverhost}/api/Event/PeopleStatistics`,

  // 打卡
  PunchTime: `${serverhost}/api/ActualEvent`,
  PunchTimeHistory: `${serverhost}/api/ActualEvent/History`,
};

// 下次班表API
export const nextShiftAPI = {
  GET: `${serverhost}/api/Event`,
};
